import { Link } from 'react-router-dom';

export default function HeroSectionFr() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/edited_68e8fd27911cc5331e39dc5da2ad3e1c_f0257be7.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-stone-900/85 via-stone-900/60 to-stone-900/30" />

      <div className="relative z-10 w-full px-6 md:px-16 flex flex-col items-start max-w-3xl">
        <span className="text-emerald-400 text-xs font-bold uppercase tracking-widest mb-4">
          Approvisionnement Mondial
        </span>
        <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
          L&apos;avantage
          <br /><span className="text-emerald-400">MAX</span>-Sourcing
        </h1>
        <p className="text-lg md:text-xl text-white/80 leading-relaxed mb-3 max-w-xl">
          <em>Nous livrons en matière d&apos;approvisionnement</em>
        </p>
        <p className="text-base text-white/75 leading-relaxed mb-10 max-w-2xl">
          Axés sur la satisfaction client et la qualité — identifier, qualifier, valider et gérer
          des sources viables, éprouvées et collaboratives de produits de qualité, de matières premières et de services de développement sur mesure.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/fr/services"
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-8 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors text-sm"
          >
            Nos Services
          </Link>
          <Link
            to="/fr/contact"
            className="border-2 border-white/60 hover:border-white text-white font-semibold px-8 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors text-sm"
          >
            Contactez-nous
          </Link>
        </div>
      </div>

      {/* Bilingual badge */}
      <div className="absolute bottom-10 right-6 md:right-16">
        <div className="bg-white/10 backdrop-blur-sm border border-emerald-400/40 rounded-lg px-5 py-4 text-center min-w-[110px]">
          <div className="text-lg font-extrabold text-emerald-400 tracking-widest">FR · EN</div>
          <div className="text-xs text-white/70 mt-1 leading-tight">Service bilingue</div>
        </div>
      </div>

    </section>
  );
}
